import React from 'react';

export default function Heading(props) {
  const { heading } = props;
  return <h2>{heading}</h2>;
}
